import React from 'react';
import { MediaItem } from '../types';

interface MediaSkeletonProps {
  media: MediaItem;
  containerDimensions?: {
    width: string;
    height: string;
    maxWidth?: string;
    maxHeight?: string;
  };
}

const MediaSkeleton: React.FC<MediaSkeletonProps> = ({ media, containerDimensions }) => {
  const getSkeletonStyle = () => {
    const baseStyle: React.CSSProperties = {
      width: '100%',
      height: '100%',
      background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
      backgroundSize: '200% 100%',
      animation: 'skeleton-loading 1.5s infinite',
      borderRadius: '8px',
      position: 'relative',
      overflow: 'hidden'
    };

    if (containerDimensions) {
      return {
        ...baseStyle,
        width: containerDimensions.width,
        height: containerDimensions.height,
        maxWidth: containerDimensions.maxWidth,
        maxHeight: containerDimensions.maxHeight,
      };
    }

    return baseStyle;
  };

  const getIconStyle = () => {
    const iconSize = Math.min(
      containerDimensions ? parseInt(containerDimensions.width) : 400,
      containerDimensions ? parseInt(containerDimensions.height) : 300
    ) * 0.15; // 15% of the smaller dimension

    return {
      position: 'absolute' as const,
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: `${iconSize}px`,
      height: `${iconSize}px`,
      opacity: 0.3,
      color: '#999'
    };
  };

  return (
    <div style={getSkeletonStyle()}>
      {/* Media type icon */}
      <div style={getIconStyle()}>
        {media.type === 'image' ? (
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M8 5v14l11-7z"/>
          </svg>
        )}
      </div>
      
      {/* Shimmer effect overlay */}
      <div 
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
          animation: 'skeleton-shimmer 2s infinite'
        }}
      />
    </div>
  );
};

export default MediaSkeleton;
